<template>
    <div class="review-item">
        <div class="d-sm-flex align-items-center justify-content-between">
            <div class="review-item__name">{{ review.name }}</div>
            <div class="d-flex align-items-center justify-content-start justify-content-sm-end">

                <RatingStars v-if="review.rating !== null" :rating="review.rating" :numberRepresentation="false"/>
                <div class="date">{{ review.created_at }}</div>
            </div>
        </div>
        <div class="review-item__text">
            {{ review.text }}
        </div>
        <div class="d-flex align-items-center justify-content-between">
            <button @click.prevent="answer(review.id)" class="answer-link">
                Відповісти
            </button>

            <button
                v-if="review.children.length" 
                class="more-answer" 
                data-toggle="collapse"
                :href="`#answers-${review.id}`" 
                role="button" 
                aria-expanded="true"
                aria-controls="answers-1"
                @click.prevent="toggleAnswers"
            >
                <span class="value">{{ answersVisible ? 'Приховати відповіді' : 'Показати відповіді' }}</span>
                ({{ review.children.length }})
            </button>

            <div class="review-likes d-flex align-items-center">
                <span class="like d-flex align-items-center" @click="likeReview(1)">
                    <span class="ic icon-like" :class="{active: user_like === 1}">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </span>
                    <span class="value">{{ likes }}</span>
                </span>
                <span class="dislike d-flex align-items-center" @click="likeReview(-1)">
                    <span class="ic icon-diselike" :class="{active: user_like === -1}">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </span>
                    <span class="value">{{ dislikes }}</span>
                </span>
            </div>
        </div>

        <div class="review-answers collapse" :id="`answers-${review.id}`" style="">
            <div v-for="children in review.children" class="review-answers-item">
                <div
                    class="review-answers-top d-sm-flex align-items-center justify-content-between">
                    <div class="review-answers-name d-flex align-items-center">
                        <div class="review-answers-icon" v-if="children.user && children.user.avatar">
                            <img :src="children.user?.avatar" alt="" class="lozad">
                        </div>
                        <div class="review-answers-names">
                            <div v-if="children.user?.role" class="name-anons">Представник магазину</div>
                            <div class="name">{{ children.name }}</div>
                        </div>
                    </div>
                    <div class="date">{{ children.created_at }}</div>
                </div>
                <div class="review-item__text" v-html="children.text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
    name: "ProductReviewItem",
    components: {
        RatingStars: defineAsyncComponent(() => import("@/frontend/Components/Common/RatingStars.vue"))
    },
    props: {
        review: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            likes: 0,
            dislikes: 0,
            user_like: null,
            answersVisible: false
        }
    },
    created() {
        this.likes = this.review.likes || 0
        this.dislikes = this.review.dislikes || 0
        this.user_like = this.review.user_like || null
    },
    methods: {
        likeReview(value) {
            value = value === this.user_like ? 0 : value;

            axios.post(this.route('frontend.review.like', this.review.id), {
                value: value
            }).then(({ data }) => {
                this.likes = data.likes || 0
                this.dislikes = data.dislikes || 0
                this.user_like = data.user_like || null
                this.$forceUpdate()
            });
        },
        answer(parent_id) {
            this.$inertia.modal(this.route('frontend.review.add', ['product', this.review.model_id]), 'get', {parent_id: parent_id})
        },
        toggleAnswers() {
            this.answersVisible = !this.answersVisible;
        }
    },
}
</script>

<style scoped>

</style>
